export function isRouteActive(
  pathname: string,
  href: string,
  matcher?: string | ((pathname: string) => boolean)
): boolean {
  if (typeof matcher === 'function') {
    return matcher(pathname);
  }

  if (typeof matcher === 'string') {
    const regex = new RegExp(matcher);
    return regex.test(pathname);
  }

  // Default: check if pathname starts with href
  return pathname.startsWith(href);
}
